import * as React from 'react';
import { ISuccessProps } from './success.types';
import { WIDGET_NAME } from '@sitegen/common/constants';

import BaseScreen from '../../modules/base-screen';
import RedemptionSuccess from '../redemption/redemption-success';
import PYCSuccess from '../pyc-redeem/success';

const SuccessWrapper: React.FC<ISuccessProps> = ({ widgetName }) => {
    return widgetName === WIDGET_NAME.PYC_REDEEM
        ? <BaseScreen>
            <PYCSuccess />
        </BaseScreen>
        : <RedemptionSuccess />;
};

export default SuccessWrapper;
